var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMidPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_295_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5 47C35.9264 47 46 36.9264 46 24.5C46 12.0736 35.9264 2 23.5 2C11.0736 2 1 12.0736 1 24.5C1 36.9264 11.0736 47 23.5 47Z",
    fill: "#684287"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.125 24.5625C45.125 36.4711 35.4712 46.125 23.5625 46.125C11.6539 46.125 2 36.4711 2 24.5625C2 12.6539 11.6539 3 23.5625 3C35.4712 3 45.125 12.6539 45.125 24.5625Z",
    stroke: "white",
    strokeWidth: 4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_295_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMidPoint);
export default __webpack_public_path__ + "static/media/mid_point.90f6d89bd3f61c88657ff1210d188491.svg";
export { ForwardRef as ReactComponent };